import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    newItemUrl: String,
  }
  static targets = ["entry", "container"]

  add(event) {
    event.preventDefault()
    const nestedFormContent = event.currentTarget.dataset.nestedFormContent;

    this.containerTarget.insertAdjacentHTML("beforeend", nestedFormContent.replace(/NEW_CHILD_INDEX/g, Date.now()))

    // fetch(this.newItemUrlValue, {
    //   headers: {
    //     Accept: "text/vnd.turbo-stream.html"
    //   }
    // })
    //   .then(response => response.text())
    //   .then(html => Turbo.renderStreamMessage(html))
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest("[data-nested-form-target='entry']")

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = "1"
      wrapper.style.display = "none"
    }
  }
}
